/**
 * Output Downscaled Media Key Status.
 *
 *
 * @beta
 */
export const OUTPUT_DOWNSCALED = 'output-downscaled'
